import { FC, useState } from 'react';
import styled from 'styled-components';

import { ButtonIw } from '@/_pages/interwill/components/ButtonIw';
import { media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { VideoDeletionConfirmModalProps } from '@/widgets/modals/types';

import { ModalContainerV2 } from '../containers/ModalContainerV2';

export const VideoDeletionConfirmModal: FC<VideoDeletionConfirmModalProps> = ({ onDelete }) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'videoDeletionConfirm' });

  const [loading, setLoading] = useState(false);

  const modals = useModalsStore();

  const onDeleteHandle = async () => {
    setLoading(true);
    await onDelete();
    modals.closeModal();
  };

  return (
    <ModalContainerV2 pinBottom title={t('title')}>
      <Content>
        <span>{t('text')}</span>
        <Buttons>
          <ButtonIw type="default" onClick={() => modals.closeModal()}>
            {t('cancel')}
          </ButtonIw>
          <ButtonIwDelete loading={loading} disabled={loading} onClick={onDeleteHandle}>
            {t('delete')}
          </ButtonIwDelete>
        </Buttons>
      </Content>
    </ModalContainerV2>
  );
};

const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 32px;
  gap: 16px;

  ${media.iwMobile} {
    flex-direction: column-reverse;
  }
`;

const Content = styled.div`
  padding: 24px 0 0;
  font-size: 14px;
`;

const ButtonIwDelete = styled(ButtonIw)`
  && {
    background: ${COLORS.systemFlame200};

    &&:hover {
      background: ${COLORS.systemFlame300};
    }
  }
`;
